import { render, staticRenderFns } from "./LessonPractice.vue?vue&type=template&id=26074533&scoped=true"
import script from "./LessonPractice.vue?vue&type=script&lang=js"
export * from "./LessonPractice.vue?vue&type=script&lang=js"
import style0 from "./LessonPractice.vue?vue&type=style&index=0&id=26074533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26074533",
  null
  
)

export default component.exports